/** Brand colors, mirrored from tokens.css for code that needs raw values (charts, PDFs, canvas). */
export const colors = {
  bg: "#092328",
  bgSoft: "#0d2d33",
  bgDeep: "#061a1d",
  line: "#1a3a40",
  lime: "#b2d235",
  cream: "#f7fff0",
  textSoft: "#a8b8bc",
} as const;

export type BrandColor = keyof typeof colors;

/** Breakpoints in rem (1rem = 16px default): phone < 48, tablet 48-64, desktop >= 64. */
export const breakpoints = { tablet: 48, desktop: 64 } as const;
